console.log(process.env.PRODUCT)
window.product = ''

export default {
  debug: process.env.DEBUG,
  product: null, // process.env.PRODUCT,
  staticBaseUrl: process.env.STATIC_BASE_URL,
  api: {
    baseUrl: process.env.API_BASE_URL
  },
  routerApi: {
    baseUrl: process.env.ROUTER_API_BASE_URL
  },
  accessRules: {
    carriers: [
      'isAdmin', // both Admin and Superadmin
      'isGcmAdmin'
    ],
    gcm2: [
      'isSuperAdmin', // just Superadmin
      'isGcmAdmin'
    ],
    full: [
      'isOperator'
    ]
  },
  geo: {
    check: 'https://geoip.maxmind.com/geoip/v2.1/country/me',
    account: '775290',
    key: 'B08h7Wv2cGX0kwUA'
  },
  auth: {
    google: {
      clientId: '996521258982-0mpmitvdpb2drggpros1qdf7c216rses.apps.googleusercontent.com'
    },
    facebook: {
      clientId: '357701778300515'
    }
  },
  integrations: {
    mercadolibre: {
      appId: process.env.MERCADOLIBRE_APPID
    },
    meli: {
      appId: process.env.MERCADOLIBRE_APPID
    },
    tiendanube: {
      appId: process.env.TIENDANUBE_APPID
    },
    shopify: {
      appId: process.env.SHOPIFY_APPID
    },
    'tienda-nube': {
      appId: process.env.TIENDANUBE_APPID
    },
    g3: {
      apiUrl: process.env.G3_INTEGRATION_API_URL,
      apiKey: process.env.G3_INTEGRATION_API_KEY
    }
  },
  validStates: [
    'DRAFT',
    'READY',
    'CONFIRMED',
    'ATPICKUPPOINT',
    'INTRANSIT',
    'ATDELIVERYPOINT',
    'DELIVERED',
    'INCIDENCE',
    'TOBERETURNED',
    'RETURNED',
    'CANCELED'
  ],
  tinMaskByType: {
    AR: {
      CUIT: '##-##.###.###-#',
      CUIL: '##-##.###.###-#',
      DNI: ['#.###.###', '##.###.###']
    },
    CL: {
      RUT: ['##.###.###-X', '#.###.###-X']
    },
    MX: {
      RFC: ['AAAA######XXX', 'AAA######XXX']
    },
    UY: {
      'C.I.': ['##.###.###-X', '#.###.###-X'],
      RUT: '##-######-###-#'
    }
  },
  tinMask: {
    AR: ['##-##.###.###-#', '##-#.###.###-#', '##.###.###', '#.###.###'],
    CL: ['##.###.###-X', '#.###.###-X'],
    CO: ['###.###.###-#', '##.###.###-#'],
    MX: ['AAAA######XXX', 'AAA######XXX'],
    PE: ['XXXXXXXXXXXXXXX'],
    UY: ['##-######-###-#', '##.###.###-X', '#.###.###-X']
  },
  GA_ACCOUNT: process.env.GA_ACCOUNT,
  maps: {
    providers: [
      {
        name: 'OpenStreetMap',
        visible: false,
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        maxZoom: 18,
        testTile: 'https://b.tile.openstreetmap.org/11/694/1236.png',
        order: 3
      },
      {
        name: 'CartoDB',
        visible: false,
        url: 'https://d1inm7pu94hsf0.cloudfront.net/{z}/{x}/{y}{r}.png',
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
        maxZoom: 18,
        testTile: 'https://d1inm7pu94hsf0.cloudfront.net/11/694/1236.png',
        order: 1
      },
      {
        name: 'Mapbox',
        visible: false,
        url: 'https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}',
        attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
        maxZoom: 18,
        options: {
          id: 'mapbox/streets-v11',
          accessToken: process.env.MAPBOX_ACCESSTOKEN,
          tileSize: 512,
          zoomOffset: -1
        },
        testTile: 'https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/10/347/618?access_token=' + process.env.MAPBOX_ACCESSTOKEN,
        order: 2
      }
    ]
  }
}
